<template>
  <div>
    <van-field name="radio" label="" >
      <template #input>
        <van-radio-group v-model="radio" direction="horizontal" v-for="item in resultList" :key="item.typecode" @change="changeVehicleUsage" :disabled="disabled">
          <van-radio :name="item.typecode" style="font-weight: bold!important;font-size: 1rem;">{{ item.typename }}</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <p v-if="disabled " class="disabled-tip">如当前用途为 蒸洗 + 装卸作业，无法修改为仅蒸洗作业</p>
  </div>
</template>
<script>
import { Toast } from "vant";
import api from "@/fetch/api";

export default{
  props: {
    vehicleUsage:{
      type: String,
      default: ""
    },
    isRequire:{
      type:Boolean,
      default:true,
    },
    disabled:{
      type:Boolean,
      default:false,
    }
  },
  data(){
    return {
      resultList:[],
      radio:"",
    }
  },
  watch:{
    vehicleUsage:function(newValue)
    {
      
        if(this.resultList.length == 0){
            this.getUsage(newValue);
        }
        else{
            this.resultList.forEach((item) => {
            if(item.typecode == newValue) this.radio = item.typecode;

        });
      }
        
    },
  },
  created()
  {
    this.getUsage();
  },
  methods:{
    getUsage(typecode)
    {
      var that = this;
      var typeGroupName = "vehicleUsage";
      api.getTypeList(typeGroupName).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.success == true) {
          var result = resData.obj;
          const newResult = [];
          console.log(resData)
          result.forEach((item) => {
            if(item.typecode){
               newResult.push(item);
               if(typecode && typecode.typecode) that.radio = item.typecode;
            }
          });
          that.resultList = newResult;
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
    changeVehicleUsage(value)
    {
        if (this.disabled) return; // 如果禁用，不执行更改操作
        
        this.resultList.forEach((item) => {
            if(item.typecode == value) this.$emit("changeVehicleUsage",item);
        });
      this.showPicker = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.disabled-tip {
  color: #ff976a;
  font-size: 12px;
  margin: 4px 16px;
  padding-left: 12px;
  border-left: 2px solid #ff976a;
}
</style>
